import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { getJobServiceAsssignedSurveyor } from "../../../../../requesters/jobServiceRequester"
import { getMyDeclinedReimbursementsCount } from "../../../../../requesters/reimbursementLineItemsRequester"
import { getBaseUrl } from "../../../reducers"

import DashboardCardContainer from "../components/DashboardCardContainer";
import DashboardCard from "../components/DashboardCard";
import GoalSummarySection from "../components/GoalSummarySection";
import TableForSurveyor from "./TableForSurveyor"


const DashboardForSurveyor = ({ currentUser }) => {
  const { id, attributes: { firstname, surveyor_goals_enabled: surveyorGoalsEnabled } } = currentUser
  const baseUrl = useSelector(getBaseUrl)
  const [jobServices, setJobServices] = useState([])
  const [jobCompleted, setJobCompleted] = useState(0)
  const [overdueData, setOverdueData] = useState([])
  const [upcomingServices, setUpcomingServices] = useState(0)
  const [inspectionRequired, setInspectionRequired] = useState(0)
  const [declinedReimbursementsCount, setDeclinedReimbursementsCount] = useState(0)

  const requestJobServices = userId => {
    getJobServiceAsssignedSurveyor(baseUrl, userId)
      .then(res => {
        if (res.status === 200) {
          const newData = Object.values(_.get(res.response.daily_jobs, "data", {}))
          setOverdueData(res?.response?.overdue_jobs)
          setJobServices(newData)
          setJobCompleted(res?.response?.completed_jobs)
          setUpcomingServices(res.response.service_required_count)
          setInspectionRequired(res.response.inspection_required_count)
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  useEffect(() => {
    requestJobServices(id)
  }, [currentUser])

  return (
    <div className="dashboard">
      <div className="row no-gutters">
        <div className="col-lg-4 col-xl-3">
          <div className="container-fluid">
            <div className="container-inner">
              <div className="greeting">
                Hello,
                {" "}
                <br />
                {" "}
                {firstname}
                {" "}
              </div>
            </div>
          </div>
        </div>
        <DashboardCardContainer title="today">
          <div className="row">
            <DashboardCard
              // link=""
              title="Jobs Completed"
              total={jobServices.length}
              ofTotal
              count={jobCompleted}
              colorClass="bg-light" />
            <DashboardCard
              link="/flagged-jobs?filter=data_overdue&is_surveyor=true"
              title="Overdue Data until Today"
              count={overdueData.length}
              colorClass="bg-coral" />
            <DashboardCard
              link="/settings/my-gear?by_status=inspection_required"
              title="Asset Inspection"
              count={inspectionRequired}
              colorClass={inspectionRequired === 0 ? "bg-light" : "bg-coral"} />
            <DashboardCard
              link="/settings/my-gear?by_status=service_required"
              title="Asset Service Due"
              count={upcomingServices}
              colorClass={upcomingServices === 0 ? "bg-light" : "bg-coral"} />
            <DashboardCard
              link="/settings/my-reimbursements"
              title="Declined Reimbursements"
              selfFetchingCount
              getCountRequester={getMyDeclinedReimbursementsCount}
              setCount={setDeclinedReimbursementsCount}
              count={declinedReimbursementsCount}
              colorClass={declinedReimbursementsCount === 0 ? "bg-light" : "bg-coral"} />
            {/* <DashboardCard
              // link=""
              title="Additional Info (RS)"
              count="0"
              colorClass="bg-coral" />
            <DashboardCard
              // link=""
              title="Additional Info (Drafting)"
              count="0"
              colorClass="bg-coral" /> */}
          </div>
        </DashboardCardContainer>
      </div>
      { surveyorGoalsEnabled && <GoalSummarySection currentUser={currentUser} /> }
      {!!jobServices.length && (<TableForSurveyor currentUser={currentUser} jobServices={jobServices} requestJobServices={requestJobServices} />)}
    </div>
  )
}

export default DashboardForSurveyor
